import type { ApiError } from "@/lib/api/api-client"

export const isApiError = (error: unknown): error is ApiError => {
  return typeof error === 'object' && error !== null && 'message' in error
}